import React, { useEffect, useReducer } from 'react'

import { ClickWrapContext } from './context'
import { ClickWrapContextAction, ClickWrapContextState } from './types'

export interface ClickWrapContextProviderProps {
  accepted: boolean
  children: React.ReactNode
}

const ClickWrapContextProvider: React.FC<ClickWrapContextProviderProps> = ({
  accepted,
  children,
}) => {
  const [state, dispatch] = useReducer(
    (prevState: ClickWrapContextState, action: ClickWrapContextAction) => {
      switch (action.type) {
        case 'acceptPending':
          return { ...prevState, acceptPending: true }
        case 'acceptChanged':
          return { ...prevState, acceptPending: false, accepted }
        case 'contentChanged':
          return { ...prevState, acceptPending: false, accepted }
        case 'setAcceptPending':
          return { ...prevState, acceptPending: action.value }
        default:
          console.error(`Invalid action (ClickWrapContextProvider): ${JSON.stringify(action)}`)
          return prevState
      }
    },
    { accepted, acceptPending: false },
    undefined,
  )

  useEffect(() => {
    dispatch({ type: 'acceptChanged' })
  }, [accepted])

  return <ClickWrapContext.Provider value={[state, dispatch]}>{children}</ClickWrapContext.Provider>
}

export default ClickWrapContextProvider
